import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilesService } from '@core/services';
import { ImageSizeEnum } from 'lingo2-models';
import { OnUiCover } from 'onclass-ui';

export interface IUserCard {
  id: string;
  userpic_id: string;
  title: string;
  description: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-classroom-user-card',
  templateUrl: './classroom-user-card.component.html',
  styleUrls: ['./classroom-user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomUserCardComponent {
  @Input() user: IUserCard;

  public get avatar(): OnUiCover {
    return {
      type: 'avatar',
      img: FilesService.getFileUrlBySize(this.user.userpic_id, ImageSizeEnum.sm),
      title: this.user.title,
      form: 'circle',
    };
  }
}
